import { atom, computed } from "nanostores"

// Enums

export enum LaunchStateType {
  Starting = "starting",
  Initializing = "initializing",
  Launched = "launched",
}

export enum ActiveTabType {
  Home = "Home",
  Properties = "Properties",
  Analyze = "Analyze",
  Loans = "Loans",
  Rewards = "Rewards",
  Events = "Events",
  None = "None",
}

export const TAB_NAMES = {
  [ActiveTabType.Home]: "Home",
  [ActiveTabType.Properties]: "Properties",
  [ActiveTabType.Analyze]: "Analyze",
  [ActiveTabType.Loans]: "Loans",
  [ActiveTabType.Rewards]: "Rewards",
  [ActiveTabType.Events]: "Events",
  [ActiveTabType.None]: "None",
}

export type ActiveTabEnumValue = keyof typeof ActiveTabType
export const $launchState = atom<LaunchStateType>(LaunchStateType.Starting)

export const $activeTab = atom<ActiveTabEnumValue>(ActiveTabType.None)
// Store update functions

export function setLaunchState(newState: LaunchStateType) {
  $launchState.set(newState)
}

export function setActiveTab(newActiveTab: ActiveTabEnumValue) {
  $activeTab.set(newActiveTab)
}

// Utility Functions

function appIsLoading(currentLaunchState: LaunchStateType) {
  return (
    currentLaunchState === LaunchStateType.Starting ||
    currentLaunchState === LaunchStateType.Initializing
  )
}

export const $appIsLoading = computed($launchState, (launchState) =>
  appIsLoading(launchState)
)
